import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card-px text-center py-20 my-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, "Welcome!", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fs-4 fw-bold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" There are no subscriptions added yet."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Kickstart your business by adding a your first subscription ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add Subscription")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-100 mh-300px",
    alt: "",
    src: "media/illustrations/dozzy-1/5.png"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          to: "/subscriptions/add-subscription",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ])
  ]))
}